function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_17",
  x: 0,
  y: 0,
  width: 130,
  height: 130,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Back_to_top",
  "data-name": "Back to top"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -45, -45)",
  filter: "url(#Ellipse_17)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_17-2",
  "data-name": "Ellipse 17",
  cx: 20,
  cy: 20,
  r: 20,
  transform: "translate(45 45)",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "Camada_1",
  "data-name": "Camada 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_384",
  "data-name": "Pfad 384",
  d: "M20,40A20,20,0,1,0,0,20,20.022,20.022,0,0,0,20,40ZM20,3.333A16.667,16.667,0,1,1,3.333,20,16.686,16.686,0,0,1,20,3.333Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_385",
  "data-name": "Pfad 385",
  d: "M613.928,471.88v14.31h3.333V471.88l3.822,3.822,2.357-2.357-7.845-7.845-7.845,7.845,2.357,2.357Z",
  transform: "translate(-595.595 -456.19)"
})));

function SvgBackToTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTop);
export default __webpack_public_path__ + "static/media/backToTop.818ec470.svg";
export { ForwardRef as ReactComponent };